import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { kits } from './models/kits';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { BreadcrumbsComponent } from '../shared/components/breadcrumbs/breadcrumbs.component';
import { BreadcrumbsOptions } from "../shared/models/breadcrumbs-model";
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { debounceTime, finalize } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { MatTooltip } from '@angular/material/tooltip';
import { ConfirmDialogComponent } from '../shared/components/dialogs/confirm/confirm.component';
import { KitService } from './services/kits.service';
import { AlertComponent } from '../shared/components/dialogs/alert/alert.component';

@Component({
  selector: 'app-kits',
  templateUrl: './kits.component.html',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    MatSelectModule,
    MatPaginator,
    MatTableModule,
    TranslateModule,
    FlexLayoutModule,
    BreadcrumbsComponent,
    MatTooltip,
  ],
  styleUrl: './kits.component.scss'
})
export class KitsComponent implements OnInit {
  breadcrumbsData: BreadcrumbsOptions = {
    title: 'general.kits',
    buttons: [
      {
        label: 'button.add-kit',
        style: 'blue',
        do: () => {
          this.navigate();
        }
      }
    ]
  };
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild('form') kitsFormViewChild: any;

  filter: FormControl = new FormControl('');
  isEdit = false;
  displayedColumns: string[] = [ 'description', 'itemsQuantity', 'action' ]
  pageable: PageEvent = {
    pageIndex: 0,
    pageSize: 5,
    length: 0
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private KitService: KitService
  ) {}

  readonly dialog = inject(MatDialog);
  kits: kits[] = [];
  dataSource = new MatTableDataSource<kits>();

  ngOnInit() {
    this.filter.valueChanges.pipe(debounceTime(1000)).subscribe(() => {
      this.pageable.pageIndex = 0;
      if (this.paginator) {
        this.paginator.firstPage();
      }
      this.pageChange(this.pageable);
    });

    this.pageChange(this.pageable);
  }

  pageChange(event: PageEvent) {
    this.pageable = event;

    const filterValue = this.filter.value?.trim() ?? '';

    this.KitService
      .listKitsPaginatedandFiltered(this.pageable, filterValue)
      .pipe(finalize(() => {
      }))
      .subscribe({
        next: (res) => {
          this.kits = res.content;
          this.dataSource = new MatTableDataSource<kits>(this.kits);
          this.pageable.length = res.totalElements;
          this.pageable.pageIndex = res.pageable.pageNumber;
          this.pageable.pageSize = res.pageable.pageSize;
        },
        error: (err) => {
          console.error('Erro ao carregar os kits:', err);
        }
      });
  }

  updateKit(id: number) {
    this.router.navigate(
      [`/details-kit/${id}`],
    );
  }

  deleteKit(kit: any) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
          data: {
            message: 'kit.deleteKitConfirmation',
            param: { description: kit.description }
          }
    });

    dialogRef.afterClosed().subscribe(result => {
          if (result.confirm) {
            this.KitService.deleteKit(kit, kit.id).subscribe({
              next: (kit) => {
                this.dialog.open(AlertComponent, {
                  disableClose: true,
                  data: {
                    message: 'kit.kitDeletedSuccess',
                    param: { description: kit.description },
                    title: 'alert.information',
                  },
                });
                this.resetTable();
              },
              error: (error) => {
                if (error.status === 409) {
                  this.dialog.open(AlertComponent, {
                    disableClose: true,
                    data: {
                      title: 'alert.information',
                      message: 'kit.cannot-delete-kit'
                    },
                });
                }
              }
            })
          }
        });
  }

  resetTable() {
    this.pageChange(this.pageable);
  }

  navigate() {
    this.router.navigate(
      ['/details-kit'],
    );
  }
}
